import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table } from 'react-bootstrap';

import PropTypes from 'prop-types';

import { faMobileAlt, faGlobe } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";




class ClaimScanView extends React.Component {
	
	constructor(props) {
		super(props);
		
		this.app = this.props.app;
		this.getMvcModuleObject = this.app.getMvcModuleObject;
		this.getMvcMyQuoteObject = this.app.getMvcMyQuoteObject;

		this.uuid = this.app.guid();

		this.bounty = this.props.bounty;
		
		this.closing = false;

		this.state = {
			message_text: 'scanning...',
			claims: []
		};
	}

	_setState(state) {
		if (this.closing !== true)
		this.setState(state);
	}

	
	// post render commit phase
	componentDidMount() {
		console.log('ClaimScanView.componentDidMount called');

		let mvcmodule = this.getMvcModuleObject();
		
		mvcmodule.registerEventListener('on_refreshPage', this.uuid, this.onRefreshPage.bind(this));

		this._scan();
	}

	async _scan() {
		if (this.bounty) {
			let mvcmodule = this.getMvcModuleObject();
			let mvcmyquote = this.getMvcMyQuoteObject();
	
			let rootsessionuuid = this.props.rootsessionuuid;
			let walletuuid = this.props.currentwalletuuid;

			let currencyuuid = this.bounty.currencyuuid;
			let bountyhash = this.bounty.txhash;

			let claims = [];
			let message_text = '';

			let canfetch = await mvcmyquote.canFetchTransactions(rootsessionuuid, walletuuid, currencyuuid);

			if (canfetch) {
				claims = await mvcmyquote.fetchClaims(rootsessionuuid, walletuuid, currencyuuid, bountyhash)
				.catch(err => {
					console.log('error in ClaimScanView._scan: ' + err);
				});
	
				message_text = 'found ' + (claims ? claims.length : 0) + ' claims';

				for (var i = 0; i < (claims ? claims.length : 0); i++) {
					claims[i].uuid = claims[i].txhash;

					claims[i].time = claims[i].blocktime;
					claims[i].formattedtime = mvcmodule.formatDate(claims[i].time, 'YYYY-mm-dd HH:MM:SS');

					let tokenamount = await mvcmyquote.getCurrencyAmount(rootsessionuuid, currencyuuid, claims[i].amount);
					let amountstring = await mvcmyquote.formatCurrencyAmount(rootsessionuuid, currencyuuid, tokenamount);
					claims[i].amountstring = amountstring;
					
					switch(claims[i].status) {
						case 0: claims[i].statusstring = mvcmodule.t('unhandled'); break;
						case -1: claims[i].statusstring = mvcmodule.t('rejection pending'); break;
						case -10: claims[i].statusstring = mvcmodule.t('rejected'); break;
						case 1: claims[i].statusstring = mvcmodule.t('payment pending'); break;
						case 10: claims[i].statusstring = mvcmodule.t('paid'); break;
							default: claims[i].statusstring = mvcmodule.t('unknown'); break;
					}
				}
	
				// sort descending claim
				if (claims)
				claims.sort(function(a,b) {return ((b.time !== undefined ? b.time : 0) - (a.time !== undefined ? a.time : 0));});
	
			}
			else {
				/*let blockshift = 1000;
			
 				let new_claims = await mvcmyquote.scanNextBlockForClaims(rootsessionuuid, currencyuuid, bountyhash, blockshift)
				.catch(err => {
					console.log('error in ClaimScanView._scan: ' + err);
				}); */				
			}
			

			this._setState({message_text, claims})
		}	
	}
	
	async onRefreshPage() {
		console.log('ClaimScanView.onRefreshPage called');
		//this._scan();
	}
	
	// end of life
	componentWillUnmount() {
		let app = this.app;
		let mvcmodule = app.getMvcModuleObject();
		
		this.closing = true;

		mvcmodule.unregisterEventListener('on_refreshPage', this.uuid);
	}

	
	// user actions
	async onClickItem(item) {
		let txhash = item.txhash;
		let currencyuuid = item.currencyuuid;

		let mvcmyquote = this.getMvcMyQuoteObject();

		let rootsessionuuid = this.props.rootsessionuuid;
		let walletuuid = this.props.currentwalletuuid;

		let claim = await mvcmyquote.fetchClaim(rootsessionuuid, walletuuid, currencyuuid, txhash)
		.catch(err => {
			console.log('error in ClaimListView.onClickItem ' + err);
		});

		if (!claim) {
			this.app.alert('Could not find claim. Claims may take a few seconds before being fully registered.')
			return;
		}

		let params = {action: 'view', txhash, currencyuuid, dataobject: claim};

		this.app.gotoRoute('claim', params);
	}

	renderItem(item){
		let mvcmodule = this.app.getMvcModuleObject();

		let formattedtime = item.formattedtime;
		let answer = (item.private_submission === true ? 'private' : mvcmodule.fitString(item.answer, 21));
		let statusstring = item.statusstring;
		let uuid= item.txhash;

		return (
			<tr key={uuid} onClick={() => this.onClickItem(item)}>
				<th>{formattedtime}</th>
				<th>{answer}</th>
				<th>{statusstring}</th>
			</tr>
		);

	}

	renderList() {
		let items = this.state.claims;

		return (
			<Table responsive>
				<thead className="ListHeader">
					<tr>
					<th>Time</th>
					<th>Answer</th>
					<th>Status</th>
					</tr>
				</thead>
				<tbody className="ListItem" >
				{items.map((item, index) => {
					return (this.renderItem(item));
				})}
				</tbody>
			</Table>
		);

	}
	
	// rendering
	render() {
		let { message_text, claims } = this.state;
		
		return (
			<div className="Container">
				{(claims && claims.length ? 
				<div>
					<div className="Title">List of Claims</div>
					<div className="TextBox">
					{message_text}
					{this.renderList()}
					</div>
				</div> :
				<></>)}
			</div>
		  );
	}
	
}


// propTypes validation
ClaimScanView.propTypes = {
	app: PropTypes.object.isRequired,
	rootsessionuuid: PropTypes.string,
};

//redux
const mapStateToProps = (state) => {
	return {
		rootsessionuuid: state.session.sessionuuid,
		pending: state.login.pending,
		success: state.login.success,
		lasterror: state.login.error,
		currentwalletuuid: state.wallets.walletuuid,
	};
}

const mapDispatchToProps = (dispatch) => {
	return {
	};
}


export {ClaimScanView};
export default connect(mapStateToProps, mapDispatchToProps)(ClaimScanView);

